import { USERS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import {
	SaveUserDataProperties,
	Section,
	UpdateUserDataProperties,
	UserBranchesRequest,
	UserPaginationProperties,
} from '../userAPIProperties';

export const User = {
	getClinicalSupervisorsTherapists: (userId: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/clinical-supervisors/${userId}/therapists`,
		}),
	getUsers: (data: UserPaginationProperties) => {
		const { page, pageSize, direction, orderBy, role, searchString, section } = data;
		const query = new URLSearchParams();

		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (role) query.set('role', role);

		if (section) {
			return FetchAPI.getJson({
				urlStr: `${USERS}/${section}/${pageSize}/${page}?${query.toString()}`,
			});
		}

		return FetchAPI.getJson({
			urlStr: `${USERS}/${pageSize}/${page}?${query.toString()}`,
		});
	},
	getUsersBySection: (data: UserPaginationProperties, section: Section) => {
		const { page, pageSize, direction, orderBy, role, searchString, caseCoordinatorId } = data;
		const query = new URLSearchParams();

		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (role) query.set('role', role);
		if (typeof caseCoordinatorId === 'string') query.set('caseCoordinatorId', caseCoordinatorId);

		return FetchAPI.getJson({
			urlStr: `${USERS}/${section}/${pageSize}/${page}?${query.toString()}`,
		});
	},
	addUser: (data: SaveUserDataProperties) =>
		FetchAPI.postJson({
			urlStr: `${USERS}`,
			data,
		}),
	getUser: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/${id}`,
		}),
	updateUser: ({ id, data }: UpdateUserDataProperties) =>
		FetchAPI.putJson({
			urlStr: `${USERS}/${id}`,
			data,
		}),
	deleteUser: (id: string) =>
		FetchAPI.deleteJson({
			urlStr: `${USERS}/${id}`,
		}),
	getSelectedUserBranches: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/${id}/branches`,
		}),

	saveUserBranches: (data: UserBranchesRequest) =>
		FetchAPI.postJson({
			urlStr: `${USERS}/${data.userId}/branches`,
			data,
		}),
};
